import { render } from "./ImageSlider.vue?vue&type=template&id=4c477eba&scoped=true"
import script from "./ImageSlider.vue?vue&type=script&lang=js"
export * from "./ImageSlider.vue?vue&type=script&lang=js"

import "./ImageSlider.vue?vue&type=style&index=0&id=4c477eba&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c477eba"]])

export default __exports__